import { DropDownListCategorySite, DropDownListDTO, eCategoryListSiteRecebimento } from 'src/app/entity/dto/dropdownlist.component';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { Router } from '@angular/router';
import { DropDownListSiteRecebimentoDTO, DropDownListStatusDTO } from './../entity/dto/dropdownlist.component';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { EnumForm } from '../entity/enum/enum-form';
import { EnumFormType } from '../entity/enum/enum-form-type';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';
import { SelectedArea } from '../shared/area-select.component';



@Injectable()
export class GeneralService {

    public urlToGetToken?: string;
    private title?: BehaviorSubject<string>;
    private userName?: BehaviorSubject<string>;
    private connectionStatus?: BehaviorSubject<boolean>;

    configurationAPI: string = environment.api + 'v1/configuration/';
    public areaSelect: SelectedArea = Number(localStorage.getItem('area-select-number'));



    constructor(protected http: HttpClient, protected route: Router) {
        this.title = new BehaviorSubject<string>('IsoForms');
        this.userName = new BehaviorSubject<string>('Administrador');
        this.connectionStatus = new BehaviorSubject<boolean>(true);
    }
    get isComercial() {
        return this.areaSelect === SelectedArea.Comercial
    }

    get isBasica() {
        return this.areaSelect === SelectedArea.Basica
    }

    get isPreBasica() {
        return this.areaSelect === SelectedArea.PreBasica
    }
    getValue(): Observable<string> {
        return this.title.asObservable();
    }

    setValue(newValue): void {
        this.title.next(newValue);
    }

    getUserNameValue(): Observable<string> {
        return this.userName.asObservable();
    }

    setUserNameValue(newValue): void {
        this.userName.next(newValue);
    }

    getConnectionStatus(): Observable<boolean> {
        return this.connectionStatus.asObservable();
    }

    setConnectionStatus(newValue): void {
        this.connectionStatus.next(newValue);
    }

    public b64DecodeUnicode(str) {
        // tslint:disable-next-line: only-arrow-functions
        return decodeURIComponent(atob(str).split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    getOptionsParams(): HttpParams {
        const params = new HttpParams()
            .set('grant_type', 'client_credentials')
            .set('client_id', '66a30c8a-a206-4707-a43c-762e37640523')
            .set('client_secret', '~56-Y2XXfja.kIBPbQGESA-8_54l4MYkG_')
            .set('scope', '66a30c8a-a206-4707-a43c-762e37640523/.default');
        return params;
    }

    getMapEnumForm(formulario: EnumForm): string {
        const mapa = new Map<EnumForm, string>();
        mapa.set(0, 'qua007');
        mapa.set(1, 'rs009');
        mapa.set(2, 'sec002');
        mapa.set(3, 'rs005');
        mapa.set(4, 'cd001_classificacao');
        mapa.set(5, 'cd001_prelimpeza');
        mapa.set(6, 'cd001_repasse');
        mapa.set(7, 'cd003');
        mapa.set(8, 'et004');
        mapa.set(9, 'qua042');
        mapa.set(12, 'cd006');
        mapa.set(14, 'make745');
        mapa.set(17, 'pc003');
        return mapa.get(formulario);
    }

    // tslint:disable-next-line: max-line-length
    orderByDropDownList(list?: Array<DropDownListDTO> | Array<DropDownListSiteRecebimentoDTO>, orderByName?: boolean): Array<DropDownListDTO> | Array<DropDownListSiteRecebimentoDTO> {
        if (orderByName) {
            return list.sort((n1, n2) => {
                if (n1.name > n2.name) {
                    return 1;
                }

                if (n1.name < n2.name) {
                    return -1;
                }

                return 0;
            });
        } else {
            return list.sort((n1, n2) => {
                if (n1.initials > n2.initials) {
                    return 1;
                }

                if (n1.initials < n2.initials) {
                    return -1;
                }
                return 0;
            });
        }
    }

    goToRoute(routeName?: string): void {
        this.route.navigate([`/${routeName}`]);
    }

    getListStatus(): DropDownListStatusDTO[] {
        const lista: Array<DropDownListStatusDTO> = new Array<DropDownListStatusDTO>();
        lista.push({ id: 0, value: false });
        lista.push({ id: 1, value: true });
        return lista;
    }

    convertNumberToString(value?: number): string {
        return value?.toLocaleString('pt-br');
    }

    convertStringToNumber(value?: string): number {
        if (isNaN(Number(value))) {
            // const stValue: string = value.toString();
            return Number(value.replace(',', '.'));
        }
        return Number(value);
    }

    replaceAll(word?: string, oldletter?: string, newLetter?: string): string {
        if (!!word) {
            word = word.replace(new RegExp(oldletter, 'g'), newLetter).trim();
        }
        return word;
    }

    createDateTimeData(date?: string, time?: string): any {
        if (date === '' || date === null) {
            return '';
        }
        if (date?.length >= 8) {
            if (date?.includes('/')) {
                date = this.replaceAll(date, '/', '');
            }
            if (time?.includes(':')) {
                time = this.replaceAll(time, ':', '');
            }

            let dt2 = new Date(Number(date.substr(date.length - 4, 4)), Number(date.substr(2, 2)) - 1, Number(date.substr(0, 2)));

            if (time?.length >= 4) {
                dt2.setHours(Number(time.substr(0, 2)), Number(time.substr(2, 2)), 0, 0);
            }
            return dt2;

        }
    }

    createDateToString(date?: string): string {
        if (date?.length >= 8) {
            date = this.replaceAll(date, '/', '');
            // tslint:disable-next-line: max-line-length
            return Number(date.substr(date.length - 4, 4)) + '-' + (Number(date.substr(2, 2))) + '-' + Number(date.substr(0, 2));
        }
    }

    createDate(date?: string): Date {
        if (date?.length >= 8 && !date?.includes('/')) {
            return new Date(Number(date.substr(date.length - 4, 4)), Number(date.substr(2, 2)) - 1, Number(date.substr(0, 2)));
        } else if (!!date) {
            date = this.replaceAll(date, '/', '');
            return new Date(Number(date.substr(date.length - 4, 4)), Number(date.substr(2, 2)) - 1, Number(date.substr(0, 2)));
        }
    }

    convertStringToDate(date?: string): string {
        if (!!date && date?.length >= 10) {
            return new Date(date).toLocaleDateString('pt-br');
        } else {
            return '';
        }
    }

    convertStringToDateOrTimeOnly(pDate?: string, isDate?: boolean): string {
        if (!!pDate && pDate?.length >= 10) {
            // tslint:disable-next-line: max-line-length
            return isDate ? new Date(pDate).toLocaleDateString('pt-br')
                : new Date(pDate).toLocaleTimeString('pt-br').substr(0, 5);
        } else {
            return '';
        }
    }
    convertMaskToTime(value: number): string {
        // Converte número para string para facilitar manipulação
        const timeString = value.toString().padStart(4, '0'); // Ex: 1030 -> "1030"
        const hours = timeString.slice(0, 2); // "10"
        const minutes = timeString.slice(2, 4); // "30"
        return `${hours}:${minutes}:00`; // Formato "HH:mm:ss"
    }

    convertTimeToMask(value: string): string {
        const [hours, minutes] = value.split(':');
        return `${hours}${minutes}`; // Ex.: "10:30:00" -> "1030"
    }
    public checkSafra(safra?: string): string {
        const currentDate: string = new Date().toLocaleDateString('pt-br');
        switch (safra) {
            case 'SUMMER':
                safra = 'VE';
                break;
            case 'WINTER':
                safra = 'IN';
                break;
            case 'SPRING':
                safra = 'PR';
                break;
            case 'AUTUMN':
                safra = 'OU';
                break;
            default:
                safra = '';
                break;
        }
        return safra += currentDate.substr(currentDate.length - 2, 2);
    }

    public timeDiffCalc(dateFuture, dateNow): number {
        let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
        // calculate days
        let days = Math.floor(diffInMilliSeconds / 86400);
        diffInMilliSeconds -= days * 86400;
        // calculate hours
        const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
        diffInMilliSeconds -= hours * 3600;
        // calculate minutes
        const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
        diffInMilliSeconds -= minutes * 60;

        // const difference = '';
        // if (days > 0) {
        // difference += (days === 1) ? `${days} day, ` : `${days} days, `;
        // }

        let result = hours + (Number(minutes) / 60);

        if (days > 0) {
            days = days * 24;
            result = days + result;
        }
        return result;
    }

    public CalcMultAndDiv(pNumber1: number, pNumber2: number): number {
        return ((pNumber1 * pNumber2) / 100);
    }

    public CalcPorc(pNumber1: number, pNumber2: number): number {
        let result = ((pNumber1 / pNumber2) * 100);
        result.toFixed(2);
        return (result);
    }

    public CalcDivPrc(pNumber1: number, pNumber2: number): number {
        return pNumber1 / pNumber2;
    }

    public CalcLitros(pNumber1: number, pNumber2: number): number {
        return ((pNumber1 / pNumber2) / 100);
    }

    public CalcTimeDiffDay(dateFuture, dateNow): number {
        let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
        return Math.floor(diffInMilliSeconds / 86400);
    }

    public CalcTimeDiffDayWithThreeParams(date1, date2, date3): number {
        let diffInMilliSeconds = Math.abs(date1 - date2 - date3) / 1000;
        return Math.floor(diffInMilliSeconds / 86400);
    }

    public CalcTimeDiffDayWithFourParams(date1, date2, date3, date4): number {
        let diffInMilliSeconds = Math.abs(date1 - date2 - (date3 - date4)) / 1000;
        return Math.floor(diffInMilliSeconds / 86400);
    }

    public CalcTon(pNumber1: number): number {
        return pNumber1 / 1000;
    }
    public isDateTimeBGreaterThanA(dateA: string, timeA: string, dateB: string, timeB: string): boolean {
        // Combine data e hora em um único objeto Date

        const dateTimeA = this.createDateTimeData(dateA, timeA)
        const dateTimeB = this.createDateTimeData(dateB, timeB)
        if (typeof dateTimeA === 'string' || typeof dateTimeB === 'string') {
            return false
        }
        // Comparar as datas
        return dateTimeB > dateTimeA;
    }
    requestGetListSiteCategory = async () => {
        const fullUri = this.configurationAPI + 'getCategorySites/';
        return await this.http.get<DropDownListCategorySite[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    requestGetListSiteRecebimento = async (category: string) => {
        const fullUri = this.configurationAPI + 'getSites/' + category;
        return await this.http.get<DropDownListSiteRecebimentoDTO[]>(fullUri, { headers: this.getOptions() }).toPromise();
    }

    public getListSiteRecebimento(): Array<DropDownListSiteRecebimentoDTO> {
        const lista: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
        lista.push({ name: 'Campo Verde', initials: 'CVE' });
        lista.push({ name: 'Itaí', initials: 'ITA' });
        lista.push({ name: 'Paracatu', initials: 'PTU' });
        lista.push({ name: 'Santa Helena de Goiás', initials: 'SHG' });
        lista.push({ name: 'Uberlândia', initials: 'UDI' });
        lista.push({ name: 'Cachoeira Dourada', initials: 'CDR' });
        lista.push({ name: 'Paracatu 2', initials: 'PTU-BÁSICA' });
        lista.push({ name: 'Petrolina', initials: 'PET' });
        return this.orderByDropDownList(lista, false);
    }

    public getListSap(): Array<DropDownListDTO> {
        const lista: Array<DropDownListDTO> = new Array<DropDownListDTO>();
        lista.push({ name: 'Pendente', id: 1 });
        lista.push({ name: 'Realizado', id: 2 });
        return this.orderByDropDownList(lista, true);
    }

    public _filterDropDownList(list?: any[], value?: string): DropDownListDTO[] {
        if (!!list && list?.length > 0) {
            if (value?.length > 0 && !!value) {
                return list.filter(option => option.name?.toLowerCase()?.includes(value?.toLowerCase()));
            } else {
                return this.orderByDropDownList(list, true);
            }
        } else {
            return new Array<DropDownListDTO>();
        }
    }

    public _filterDropDownListSiteRecebimento(list?: any[], value?: string): DropDownListDTO[] {
        if (!!list && list?.length > 0) {
            if (value?.length > 0 && !!value) {
                return list.filter(option => option.initials?.toLowerCase()?.includes(value?.toLowerCase()));
            } else {
                return this.orderByDropDownList(list, false);
            }
        } else {
            return new Array<DropDownListDTO>();
        }
    }

    public getEnumFormType(option?: EnumFormType): string {
        const formType = new Map<EnumFormType, string>();
        formType.set(EnumFormType.List, 'Lista');
        formType.set(EnumFormType.New, 'Novo');
        formType.set(EnumFormType.Edit, 'Edição');
        formType.set(EnumFormType.Details, 'Detalhes');
        formType.set(EnumFormType.Duplicate, 'Duplicado');

        return formType.get((option));
    }

    public async getDataFromLocalStorage(fileName?: string): Promise<any> {
        let path: string = 'data_';
        path = path.concat(fileName);
        if (localStorage.hasOwnProperty((path))) {
            let data = JSON.parse(localStorage.getItem(path));
            return data;
        }
        return [];
    }

    public createHeader(screenForm?: EnumForm, screenType?: EnumFormType): CabecalhoDTO {
        const header: CabecalhoDTO = new CabecalhoDTO();
        header.ScreenName = this.getScreenName(screenForm);
        header.titleCard = this.getTitleCard(screenForm);
        header.titleModule = 'Formulário';
        header.ScreenType = this.getEnumFormType(screenType);
        return header;
    }

    private getScreenName(enumForm?: EnumForm): string {
        const mapa = new Map<EnumForm, string>();
        mapa.set(1, 'SEM-PRO-FOR-QUA-007');
        mapa.set(2, 'SEM-PRO-FOR-RS-009');
        mapa.set(3, 'SEM-PRO-FOR-SEC-002');
        mapa.set(4, 'SEM-PRO-FOR-RS-005');
        mapa.set(5, 'SEM-PRO-FOR-CD-001');
        mapa.set(6, 'SEM-PRO-FOR-CD-003');
        mapa.set(7, 'SEM-PRO-FOR-ET-004');
        mapa.set(8, 'SEM-PRO-FOR-QUA-042');
        mapa.set(12, 'SEM-PRO-FOR-CD-006');
        mapa.set(13, 'Estratégia de torre (Sequência e orientações)');
        mapa.set(14, 'CPB-MAKE-000745 - Ensaque CS');
        mapa.set(15, 'Configuração de Classificação - Camisa de Trieur');
        mapa.set(16, 'SEM-PRO-FOR-RS-005');
        mapa.set(17, 'PC-003');
        mapa.set(18, 'UMIDADE')
        return mapa.get(enumForm);
    }

    private getTitleCard(enumForm?: EnumForm): string {
        const mapa = new Map<EnumForm, string>();
        mapa.set(1, 'Registro de Entrada de RW na balança');
        mapa.set(2, 'Determinação de MPL');
        mapa.set(3, 'Controle da Eficiência de Secagem');
        mapa.set(4, 'Despalha e Seleção');
        mapa.set(5, 'Avaliação da Classificação e Reclassificação de Sementes');
        mapa.set(6, 'Avaliação de Sementes nos Equipamentos de Limpeza');
        mapa.set(7, 'Registro de Tratamento');
        mapa.set(8, 'Controle Diário de Ensaque');
        mapa.set(9, 'Reclassificação de Sementes');
        mapa.set(10, 'Repasse');
        mapa.set(12, 'Rendimento de Peneiras');
        mapa.set(13, 'Estratégia de torre (Sequência e orientações)');
        mapa.set(14, 'CPB-MAKE-000745 - Ensaque CS');
        mapa.set(15, 'Configuração de Classificação - Camisa de Trieur');
        mapa.set(16, 'Seleção e Debulha');
        mapa.set(17, 'PC-003');
        mapa.set(18, 'Umidade')
        mapa.set(99, 'Desconhecido');
        return mapa.get(enumForm);
    }

    public orderByDropDownListDate(list?: Array<any>) {
        if (!!list && list?.length > 0) {
            return list.sort((n1, n2) => {
                if (n1.created_at > n2.created_at) {
                    return 1;
                }

                if (n1.created_at < n2.created_at) {
                    return -1;
                }

                return 0;
            });
        }
    }

    public roundValue(value: number): number {
        return !!value ? Math.round(value * 100) / 100 : 1;
    }

    public numberMultipleOf(value: number, multiple: number) {
        return value % multiple === 0 ? true : false;
    }

    public getListLinhaDescarga(): DropDownListDTO[] {
        const list: DropDownListDTO[] = [];
        list.push({ id: 1, name: '1' });
        list.push({ id: 2, name: '2' });
        list.push({ id: 3, name: '3' });
        list.push({ id: 4, name: '4' });
        list.push({ id: 5, name: 'Manual' });
        return this.orderByDropDownList(list);
    }

    public getListUnidadeMedidaVelocidadeEsteira(): DropDownListDTO[] {
        const list: DropDownListDTO[] = [];
        list.push({ id: 1, name: 'HZ' });
        list.push({ id: 2, name: '%' });
        return this.orderByDropDownList(list);
    }

    public isValidDate(valueDate: string, valueHour: string): boolean {
        if (!!valueDate && !!valueHour) {
            if (valueDate.length >= 8) {
                return true;
            }
        }
        return false;
    }


    public isValidRangeDate(startDate: string, endDate: string): boolean {


        if (endDate != null && startDate != null) {
            const [day, month, year] = startDate.split('/');
            const [day_, month_, year_] = endDate.split('/');

            const startDatein = new Date(+year, +month - 1, +day);
            const endDatein = new Date(+year_, +month_ - 1, +day_);
            if (endDatein !== null && startDatein !== null && endDatein < startDatein) {
                return true;
            } else { return false; }


        }
        return false;

    }


    public isValidRangeHour(startHour: string, endHour: string, startDate: string, endDate: string): boolean {

        if (endHour != null && endDate != null && startDate != null && startHour) {


            const [day, month, year] = startDate.split('/');
            const [hours, minutes] = startHour.split(':');
            const [day_, month_, year_] = endDate.split('/');
            const [hours_, minutes_] = endHour.split(':');
            const startDateHour = new Date(+year, +month - 1, +day, +hours, +minutes);
            const endDateHour = new Date(+year_, +month_ - 1, +day_, +hours_, +minutes_);



            if (endDateHour < startDateHour) {

                return true;


            } else { return false; }

        }
        return false;
    }

    public setConnectionStatusNetwork(status: boolean) {
        if (!!localStorage.getItem('statusNetwork')) {
            localStorage.setItem('statusNetwork', JSON.stringify(status));
        } else {
            localStorage.setItem('statusNetwork', JSON.stringify(status));
        }
    }

    getMapEnumFormDesc(value: string): EnumForm {
        const mapa = new Map<string, EnumForm>();
        mapa.set('qua007', EnumForm.FormQua007);
        mapa.set('rs009', EnumForm.FormRs009);
        mapa.set('sec002', EnumForm.FormSec002);
        mapa.set('rs005', EnumForm.FormRs005);
        mapa.set('cd001_classificacao', EnumForm.FormCd001Classificacao);
        mapa.set('cd001_prelimpeza', EnumForm.FormCd001PreLimpeza);
        mapa.set('cd001_repasse', EnumForm.FormCd001Repasse);
        mapa.set('cd003', EnumForm.FormCd003);
        mapa.set('et004', EnumForm.FormEt004);
        mapa.set('qua042', EnumForm.FormQua042);
        mapa.set('cd006', EnumForm.FormCd006);
        mapa.set('manageSequence', EnumForm.ManageSequence);
        return mapa.get(value);
    }

    public getLocalStorageDataSite(): string {
        if (!!localStorage.getItem('data_site')) {
            return localStorage.getItem('data_site');
        }
        return '';
    }

    public getCentroEnsaqueByLocalStorageDataSite(): string {
        const site: string = this.getLocalStorageDataSite();
        const map: Map<string, string> = new Map<string, string>();
        map.set('CVE', '1222');
        map.set('UDI', '1183');
        map.set('ITA', '1173');
        map.set('SHG', '1076');
        map.set('PTU', '1040');
        map.set('PTU-BÁSICA', '1040');
        map.set('CDR', '1160');
        map.set('PET', '1951');
        return !!site ? map.get(site?.toUpperCase()?.trim()) : '';
    }

    public getAccessUpload(params) {
        return this.http.post<any>(`${environment.api}v1/upload/access`, { user_name: params }, { headers: this.getOptions() });
    }

    public postUploadPc003(file, fileName) {
        return this.http.post<any>(`${environment.api}v1/save/file/s3`, { data: file, file_name: fileName }, { headers: this.getOptions() });
    }

    getOptions(): HttpHeaders {
        const headers = new HttpHeaders()
            .set('content-type', 'application/json')
            .set('Access-Control-Allow-Origin', '*')
            .set('Authorization', `Bearer ${this.getCookie()}`);
        return headers;
    }

    private getCookie(): string {
        const name = 'frontend-app=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length).trim();
            }
        }
        return '';
    }

    applyFilter(value: string, originalList: any[], filteredList: any[]) {
        const searchTerm = value?.toLowerCase() || '';
        if (searchTerm) {
            const filteredResults = originalList.filter(item =>
                item.name?.toLowerCase().includes(searchTerm)
            );

            filteredList = filteredResults.length > 0 ? filteredResults : originalList;
        } else {
            filteredList = originalList;
        }

        return filteredList;
    }

}
